import React from "react";
import RubyQuickFixesWidget from "./RubyQuickFixesWidget";

interface AskRubyAIVulnerabilityWidgetProps {
  activeTab?: string;
  onIssueFixed?: () => void;
}

const AskRubyAIVulnerabilityWidget: React.FC<AskRubyAIVulnerabilityWidgetProps> = ({
  activeTab = "overview",
  onIssueFixed,
}) => (
  <RubyQuickFixesWidget cardId="ai-vulnerability" activeTab={activeTab} onIssueFixed={onIssueFixed} />
);

export default AskRubyAIVulnerabilityWidget;
